import iro from '@jaames/iro';

const config = {
    queryDict: true, // to store GET parameters
    testCurves: {
        enabled: false,
        smartCurve: false, // Whether or not we should display the curves in test container
    },
    blocks: [
        {
            type: 'control',
            label: 'Controls',
            controls: [
                {
                    name: 'customLUT',
                    icon: 'image_aspect_ratio',
                    label: 'Add Custom 3D LUT',
                },
            ],
        },
        {
            type: 'creative-block',
            label: 'Creative Blocks',
            controls: [
                {
                    name: "LUTcontrols",
                    category: "Log conversion",
                    icon: "waves",
                    label: "Log conversion",
                    LUTbased: true,
                }
            ],
        },
    ],
};

config.startFixedPasses = 1; // number of fixed passes going from start
config.endFixedPasses = 1; // number of fixed passed going from end

config.fixedControlBlocks = [
    'ExposureV2',
    'ContrastV2',
    'WhiteBalance'
];

// Color Wheel options
config.colorWheelOptions = {
    width: 100,
    layout: [
        {
            component: iro.ui.Wheel,
            options: {
                padding: -2,
                handleRadius: 4,
            },
        },
    ],
};

export default config;
